import React, { Component, Fragment } from 'react';

const isHMobile = window.innerWidth < 768;

class CobrandBar extends Component {
  state = {
    email: '',
    firstName: '',
    iata: '',
    lastName: '',
    masterAgencyId: 0,
    visible: false,
    showDefault: false,
    showModal: false,
    structure: {
      label: '',
      labelColor: '',
      labelSize: '',
      mobileLabelSize: '',
      backgroundColor: '',
      popup: {
        description: '',
        logo: '',
        buttonLabel: '',
        termsAndConditions: {
          label: '',
          link: ''
        }
      }
    }
  }

  async componentDidMount() {
    const size = Object.keys(window._app.cobrand).length;

    if (size > 0) {
      const cobrandURL =
        'https://cdn.sandals.com/cobrand/cobrand-agency-status.json';
      const cobrandStructure = await fetch(cobrandURL).then(
        (response) => response.json()
      );
      const { email, firstName, iata, lastName, masterAgencyId, agency, agencyStatus } = window._app.cobrand;
      const structureFound = Object.keys(cobrandStructure).find((cobrand) => cobrand === agencyStatus);
      const showDefault = structureFound ? false : true;

      if(structureFound) {
        this.setState({structure: cobrandStructure[structureFound]});
      }

      this.setState({ email, firstName, iata, lastName, masterAgencyId, visible: true, agency, showDefault });
    } else {
      this.setState({ visible: false });
    }
  }

  _showModal(show) {
    document.body.style.overflow = show ? 'hidden' : 'auto';
    this.setState({showModal: show});
  }

  render() {
    const { agency, firstName, lastName, showDefault, visible, structure, showModal } = this.state;
    const {label, labelColor, labelSize, mobileLabelSize, backgroundColor, popup} = structure;

    return(
      <Fragment>
        { visible && showDefault &&
          <div className="da-cobrand">
            <div className="container">
              <span className="refered-by">referred by: </span>
              <span className="name">{ firstName } { lastName }, { agency }</span>
            </div>
          </div>
        }
        {visible && !showDefault &&
          <div className="custom-cobrand" style={{backgroundColor: backgroundColor}}>
            <p className="label" style={{color: labelColor, fontSize: isHMobile ? mobileLabelSize : labelSize}}>{label}</p>
            <i className="icon-information" onClick={() => this._showModal(true)}/>
          </div>
        }
        {visible && showModal &&
          <div className="cobrand-popup-container">
            <div className="cobrand-popup">
              <i className="icon-close-simple" onClick={() => this._showModal(false)} />
              <div className="content">
                <img className="popup-logo" src={`${popup.logo}`} />
                <p className="popup-description">{popup.description}</p>
                <button className="continue-popup" onClick={() => this._showModal(false)}>{popup.buttonLabel}</button>
                <a className="popup-terms" target="_blank" href={popup.termsAndConditions.link}>{popup.termsAndConditions.label}</a>
              </div>
            </div>
          </div>
        }
      </Fragment>
    );
  }
}

export default CobrandBar;



// WEBPACK FOOTER //
// ./js/components/global/CobrandBar.js